<template>
  <div>
    <el-table class="table-normal manage w-100" :data="data">
      <el-table-column label="สิทธิ์ผู้ใช้งาน" min-width="150px">
        <template slot-scope="scope">
          <p class="text-left mg-0">
            {{ scope.row.roleName }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="จำนวนฝ่าย" prop="department" width="150px">
      </el-table-column>
      <el-table-column label="จำนวนส่วน" prop="division" width="150px">
      </el-table-column>
      <el-table-column label="จำนวนสมาชิก" prop="employee" width="150px">
      </el-table-column>
      <el-table-column label="" width="180px">
        <template slot-scope="scope">
          <div class="set-status-role">
            <el-button
              @click="$emit('openDailog', 'moreDetail', scope.row._id,scope.row.roleName)"
              class="btn-color4"
              :class="scope.row._id == 0 ? 'disabled' : ''"
            >
             <i class="fas fa-list-ul"></i>
            </el-button>
            <el-button
              @click="$emit('openDailog', 'view', scope.row._id)"
              class="btn-color1"
              :class="scope.row._id == 0 ? 'disabled' : ''"
            >
              <i class="fas fa-eye"></i>
            </el-button>
            <el-button
              @click="$emit('openDailog', 'edit', scope.row._id)"
              class="btn-color2"
              :class="
                scope.row._id == 0
                  ? 'disabled'
                  : scope.row.roleLevel > 0
                  ? 'disabled'
                  : ''
              "
              v-if="permissionMore"
            >
              <i class="fas fa-edit"></i>
            </el-button>
            <el-button
              v-if="permissionMore"
              @click="$emit('openDailog', 'delete', scope.row._id)"
              :class="
                scope.row._id == 0
                  ? 'disabled'
                  : scope.row.roleLevel > 0
                  ? 'disabled'
                  : ''
              "
              class="btn-color3"
            >
              <i class="fas fa-trash-alt"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ["data", "permissionMore"],
  methods: {},
};
</script>